import React from 'react';
import {Image, ImageProps} from '@chakra-ui/react';

const LOGO_TOKEN = 'pk_S0ubiMACTzWOjZEZr6Os-g';

type CompanyLogoProps = ImageProps & {
  domain: string;
  name: string;
};

export const CompanyLogo = ({
  domain,
  name,
  boxSize = '32px',
  ...props
}: CompanyLogoProps) => {
  const logoSrc = `https://img.logo.dev/${domain}?token=${LOGO_TOKEN}&fallback=404`;

  return (
    <Image
      src={logoSrc}
      alt={name}
      boxSize={boxSize}
      fallbackSrc="/accountFallback.png"
      {...props}
    />
  );
};
